import { Column } from "@faire/web--source/slate/Layout";
import { Modal } from "@faire/web--source/slate/Modal";
import {
  getSpacing,
  GrowingSpacer,
  Spacer,
} from "@faire/web--source/slate/spacing";
import React from "react";
import styled, { css } from "styled-components";

import { useLoggedOutContactUsNavigation } from "../hooks/useLoggedOutContactUsNavigation";

import { LoggedOutContactUsStepCta } from "./LoggedOutContactUsStepCta";
import { LoggedOutContactUsStepView } from "./LoggedOutContactUsStepView";

export const LoggedOutContactUsModal: React.FC = () => {
  const { isFirstStep, isLastStep, goToPrevStep, closeModal } =
    useLoggedOutContactUsNavigation();

  const onBack = !isFirstStep && !isLastStep ? goToPrevStep : undefined;

  return (
    <Modal
      onClose={closeModal}
      onBack={onBack}
      shouldCloseOnOverlayClick={false}
      width="600px"
    >
      <Container $isLast={isLastStep}>
        <Spacer height="4x" />
        <LoggedOutContactUsStepView />
        <GrowingSpacer />
        <LoggedOutContactUsStepCta />
      </Container>
    </Modal>
  );
};

const Container = styled(Column).attrs({
  align: "stretch",
  justify: "space-between",
})<{ $isLast: boolean }>`
  padding: ${getSpacing("8x", "3x", "4x")};
  width: 100%;
  ${(props) =>
    !props.$isLast
      ? css`
          min-height: 700px;
        `
      : css`
          height: auto !important;
        `}
`;
